import { Check, Close } from '@mui/icons-material';
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../StructuredContentRenderer';

type Props = {
  prosList?: string[] | StructuredContentDocument[];
  consList?: string[] | StructuredContentDocument[];
};

export const ColoredBulletsProsAndCons = ({ prosList, consList }: Props) => {
  const hasPros = prosList && prosList.length > 0;
  const hasCons = consList && consList.length > 0;

  if (!hasPros && !hasCons) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: {
          xs: 'column',
          md: 'row',
        },
        gap: 4,
        svg: {
          height: 22,
          width: 22,
        },
      }}
    >
      {hasPros && (
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="textBold"
            sx={{
              marginBottom: 1,
              display: 'block',
              color: 'greens.dark',
            }}
          >
            Pros
          </Typography>
          <List sx={{ listStyleType: 'disc', p: 0 }}>
            {prosList.map((bullet, index) => (
              <ListItem
                disablePadding
                key={`bullet-${index}`}
                sx={{ paddingY: 0.5, display: 'flex', alignItems: 'flex-start', gap: 1 }}
              >
                <Box
                  sx={{
                    display: 'grid',
                    marginTop: 1,
                    placeItems: 'center',
                    svg: {
                      width: 14,
                      height: 14,
                    },
                    borderRadius: '50%',
                    bgcolor: 'greens.lightest',
                    minWidth: '16px',
                    minHeight: '16px',
                  }}
                >
                  <Check color="success" />
                </Box>{' '}
                <ListItemText>
                  {typeof bullet === 'string' ? bullet : <StructuredContentRenderer doc={bullet} />}
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </Box>
      )}
      {hasCons && (
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="textBold"
            sx={{
              marginBottom: 1,
              display: 'block',
              color: 'reds.darkest',
            }}
          >
            Cons
          </Typography>
          <List sx={{ listStyleType: 'disc', p: 0 }}>
            {consList.map((bullet, index) => (
              <ListItem
                disablePadding
                key={`bullet-${index}`}
                sx={{
                  paddingY: 0.5,
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 1,
                  fontSize: 13,
                }}
              >
                <Box
                  sx={{
                    display: 'grid',
                    marginTop: 1,
                    placeItems: 'center',
                    svg: {
                      width: 14,
                      height: 14,
                    },
                    borderRadius: '50%',
                    bgcolor: 'reds.lightest',
                    minWidth: '16px',
                    minHeight: '16px',
                  }}
                >
                  <Close color="error" />
                </Box>{' '}
                <ListItemText>
                  {typeof bullet === 'string' ? bullet : <StructuredContentRenderer doc={bullet} />}
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};
